import React from 'react';
import styles from './styles.module.scss';
import HeroChoosing from './HeroChoosing';
import TimeLockChoosing from './TimeLockChoosing';
import Deposit from './Deposit';
import StakeAndLock from './StakeAndLock';

const HigherRewardContent = ({
  numberSelected,
  planStake,
  est,
  setPlanStake,
  totalPrice,
  showConfirmForm,
  chooseHero,
  thgPerHero
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement(HeroChoosing, {
    numberSelected: numberSelected,
    chooseHero: chooseHero,
    thgPerHero: thgPerHero
  }), /*#__PURE__*/React.createElement(TimeLockChoosing, {
    planStake: planStake,
    est: est,
    setPlanStake: setPlanStake
  }), /*#__PURE__*/React.createElement(Deposit, {
    totalPrice: totalPrice,
    thgPerHero: thgPerHero
  }), /*#__PURE__*/React.createElement(StakeAndLock, {
    totalPrice: totalPrice,
    showConfirmForm: showConfirmForm,
    planStake: planStake,
    numberSelected: numberSelected
  }));
};

export default HigherRewardContent;